var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Grid, LinearProgress, Typography, Box } from '@mui/material';
import { format } from 'date-fns';
import { get as getApi } from '../../api/deliveryRequest';
import { useRequest } from '../../hooks/requestHook';
import OriginalPageLayout from '../atoms/PageLayout';
import DeliveryRequestItemsTable from '../organisms/DeliveryRequestItemsTable';
import DeliveryRequestStatusTag from '../atoms/DeliveryRequestStatusTag';
import { DeliveryRequestIcon } from '../atoms/Icons';
import IconLink from '../atoms/IconLink';
import { useRoaster } from '../../hooks/useRoaster';
import Button from '../atoms/BaseButton';
import FullScreenDialog from '../molecules/FullScreenDialog';
import RoasterDeliveryRequestsEditForm from '../organisms/RoasterDeliveryRequestEditForm';
var PageLayout = styled(OriginalPageLayout)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  h5.sub-title {\n    margin: 16px 0;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n"], ["\n  h5.sub-title {\n    margin: 16px 0;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #e0e0e0;\n  }\n"])));
var StyledTypography = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: red;\n"], ["\n  color: red;\n"])));
var defaultRender = function (value) { return value; };
var renderDateTime = function (value) {
    return format(new Date(value), 'yyyy-MM-dd HH:mm:ss');
};
var RoasterDeliveryRequestDetailPage = function () {
    var _a = useParams().id, id = _a === void 0 ? '' : _a;
    var t = useTranslation().t;
    var getDeliveryRequest = useRequest(getApi);
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(), deliveryRequest = _c[0], setDeliveryRequest = _c[1];
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var roaster = useRoaster().roaster;
    var navigate = useNavigate();
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getDeliveryRequest({ id: id })];
                    case 1:
                        response = _a.sent();
                        if (canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        if (!response)
                            return [2 /*return*/];
                        setDeliveryRequest(response);
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [id, getDeliveryRequest]);
    var renderStatus = React.useCallback(function () {
        if (!deliveryRequest)
            return null;
        return React.createElement(DeliveryRequestStatusTag, { deliveryRequest: deliveryRequest });
    }, [deliveryRequest]);
    var renderTrackingUrl = React.useCallback(function (value) {
        if (value.trim().length === 0)
            return null;
        return (React.createElement(IconLink, { external: true, to: value, icon: React.createElement(DeliveryRequestIcon, { color: "secondary" }), title: t('params.trackingUrl') }));
    }, [t]);
    var renderRequestDate = React.useCallback(function (value) {
        if (!value)
            return t('labels.fastestDeliveryRequest');
        return format(new Date(value), 'yyyy-MM-dd');
    }, [t]);
    var shownItems = React.useMemo(function () {
        var _a;
        return [
            { field: 'id', render: defaultRender },
            { field: 'requestDate', render: renderRequestDate },
            { field: 'createdAt', render: renderDateTime },
            { field: 'status', render: renderStatus },
            { field: 'deliveryCompany', render: defaultRender },
            { field: 'trackingNumber', render: defaultRender },
            { field: 'trackingUrl', render: renderTrackingUrl },
            { field: 'storeName', render: defaultRender },
            { field: 'personName', render: defaultRender },
            { field: 'nameKana', render: defaultRender },
            { field: 'postalCode', render: defaultRender },
            { field: 'prefecture', render: defaultRender },
            { field: 'city', render: defaultRender },
            { field: 'address', render: defaultRender },
            { field: 'building', render: defaultRender },
            { field: 'phone', render: defaultRender },
            {
                field: 'eoriNumber',
                render: defaultRender,
                hide: !((_a = roaster === null || roaster === void 0 ? void 0 : roaster.country) === null || _a === void 0 ? void 0 : _a.eoriNumberEnabled),
            },
            { field: 'note', render: defaultRender },
        ];
    }, [renderStatus, renderTrackingUrl, roaster]);
    var handleRequested = React.useCallback(function (deliveryRequests) {
        if (!deliveryRequest)
            return;
        var updatedRequest = deliveryRequests.find(function (item) { return item.id === deliveryRequest.id; });
        if (updatedRequest) {
            setDeliveryRequest(updatedRequest);
        }
        else {
            navigate("/roaster/delivery_requests/".concat(deliveryRequests[0].id));
        }
        setOpen(false);
    }, [deliveryRequest, navigate]);
    if (loading || !deliveryRequest || !roaster)
        return React.createElement(LinearProgress, null);
    return (React.createElement(PageLayout, { title: t('pages.deliveryRequestDetail.title'), backLinkTo: "/roaster/delivery_requests" },
        deliveryRequest.isCampaignTarget && (React.createElement(StyledTypography, null, t('labels.couponTarget'))),
        React.createElement(Typography, { variant: "h5", className: "sub-title" }, t('pages.deliveryRequestDetail.basicInfo')),
        React.createElement(Grid, { container: true, spacing: 1, alignItems: "center", marginBottom: 2 },
            shownItems
                .filter(function (_a) {
                var hide = _a.hide;
                return !hide;
            })
                .map(function (_a) {
                var field = _a.field, render = _a.render;
                return (React.createElement(React.Fragment, { key: field },
                    React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                        React.createElement(Typography, { variant: "subtitle1" },
                            t("params.deliveryRequest.".concat(field), '') ||
                                t("params.".concat(field)),
                            ":")),
                    React.createElement(Grid, { item: true, xs: 12, sm: 9, style: { wordBreak: 'break-all' } }, render(deliveryRequest[field]))));
            }),
            React.createElement(Grid, { item: true, xs: 12, sm: 3 },
                React.createElement(Typography, { variant: "subtitle1" },
                    t('detail'),
                    ":")),
            React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                React.createElement(DeliveryRequestItemsTable, { items: deliveryRequest.items, role: "roaster" })),
            deliveryRequest.status === 'requested' && (React.createElement(React.Fragment, null,
                React.createElement(Grid, { item: true, xs: 12, sm: 3 }),
                React.createElement(Grid, { item: true, xs: 12, sm: 9 },
                    React.createElement(Box, { sx: { mt: 1 } },
                        React.createElement("div", null,
                            React.createElement(Typography, { variant: "caption" }, t('pages.warehouseItems.editDeliveryRequest.caption'))),
                        React.createElement(Button, { color: "success", variant: "contained", size: "small", onClick: function () { return setOpen(true); } }, t('pages.warehouseItems.editDeliveryRequest.button')))),
                React.createElement(FullScreenDialog, { title: t('pages.warehouseItems.deliveryRequest'), open: open, onClose: function () { return setOpen(false); } },
                    React.createElement(RoasterDeliveryRequestsEditForm, { roaster: roaster, warehouseItemIds: deliveryRequest.items.map(function (item) { return item.warehouseItem.id; }), onSuccess: handleRequested })))))));
};
export default RoasterDeliveryRequestDetailPage;
var templateObject_1, templateObject_2;
